import React, { useState, useEffect, useRef, useMemo } from "react";
import { Box } from "@twilio-paste/core";
import { useTheme } from "@twilio-paste/theme";

import { ReduxParticipant } from "../../store/reducers/participantsReducer";
import NewParticipantsView from "./NewParticipantsView";
import { ConversationDto } from "../../dto/conversation";
import { buildTitleFromConversation } from "./NewConversationsList";
import { ConversationSearchDrawer } from "./ConversationSearchDrawer";
import type { Conversation } from "@twilio/conversations";
import ConversationActions from "./ConversationActions";

interface NewConversationDetailsProps {
  convoSid: string;
  participants: ReduxParticipant[];
  convo: ConversationDto;
  sdkConvo: Conversation;
  /** Callback verso l’alto per rinominare la conversazione lato backend */
  // updateConvoName: (title: string) => void;
}

const NewConversationDetails: React.FC<NewConversationDetailsProps> = (
  props
) => {
  const theme = useTheme();
  const [isManageParticipantOpen, setIsManageParticipantOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const baseTitle = useMemo(
    () => buildTitleFromConversation(props.convo),
    [props.convo]
  );

  const [editedText, setEditedText] = useState(baseTitle);
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    setEditedText(baseTitle);
  }, [baseTitle]);

  const handleEditClick = () => {
    setEditedText(baseTitle);
    setIsEditing(true);
  };

  const handleInputChange = (convoName: string) => {
    setEditedText(convoName);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(event.target as Node)
      ) {
        setIsEditing(false);
        if (editedText !== baseTitle) {
          //  props.updateConvoName(editedText);
        }
      }
    };

    const handleKeyPress = (event: KeyboardEvent) => {
      if (event.key === "Enter") {
        setIsEditing(false);
        if (editedText !== baseTitle) {
          //props.updateConvoName(editedText);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleKeyPress);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [editedText, baseTitle, props]);

  return (
    <Box
      style={{
        minHeight: 65,
        maxHeight: 65,
        paddingLeft: 16,
        paddingRight: 16,
        borderBottomStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: theme.borderColors.colorBorderWeak,
      }}
    >
      <Box
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
          color="colorText"
          fontFamily="fontFamilyText"
          fontSize="fontSize50"
          lineHeight="lineHeight80"
          fontWeight="fontWeightBold"
          maxHeight="100%"
          onClick={handleEditClick}
        >
          {baseTitle} - TEAM: {props.convo.teamName}
        </Box>

        <Box
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          {/* <NewParticipantsView
            participants={props.participants}
            onParticipantListOpen={() => setIsManageParticipantOpen(true)}
          />*/}
          <Box display="flex" columnGap="space40" alignItems="center">
            <ConversationSearchDrawer sdkConvo={props.sdkConvo!} />
            <ConversationActions conversationId={props.convo.id} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default NewConversationDetails;
